// extracted by mini-css-extract-plugin
export default {"newGame":"NewGame_newGame__7W2w8","buttonDiv":"NewGame_buttonDiv__lj-pD","button":"NewGame_button__9WWGR"};